import ErrorPage from '../../app/components/Common/ErrorPage'

// Overrides default preFetcher in app.server.js
ErrorPage.preFetcher = ({ store, req, res }) => {
  // fetch user profile
  return Promise.resolve()
}

export default ErrorPage
